<template>
  <component :is="brandLogoComponent" :brand-name="brandFullName" />
</template>

<script>
import getBrandConfig from '@/lib/utils/get_brand_config';
import BannerLogoPpi from './banner_logo_ppi';
import BannerLogoAssante from './banner_logo_assante';
import BannerLogoWb4a from './banner_logo_wb4a';

export default {
  components: {
    BannerLogoPpi,
    BannerLogoAssante,
    BannerLogoWb4a,
  },
  data() {
    const brandConfig = getBrandConfig();

    return {
      brandIdentifier: brandConfig.brand,
      brandFullName: brandConfig.fullName,
    };
  },
  computed: {
    brandLogoComponent() {
      return `banner-logo-${this.brandIdentifier}`;
    },
  },
};
</script>
